import PlatformsImage from "./platforms-image";
import PlatformsIcon from "./platforms-icon";

export { PlatformsImage, PlatformsIcon };
